export const border = '1px solid #EEEEEE'



// WEBPACK FOOTER //
// ./src/styles/index.js